// Реквизиты продавца для публичных страниц (подвал, контакты, политика, возврат). Меняются только здесь.
export const REQUISITES = {
  brand: '291Cargo',
  owner: 'ИП Азнабаев',
  iin: '871012350582',
  address: 'г. Темиртау, Металлургов 23Б',
  phone: '+7 707 909 58 72',
  phoneRaw: '77079095872',
  email: 'info@291cargo.cc', // адрес для претензий (если пусто — строка не показывается)
  hours: 'с 9:00 до 20:00',
  pickup: 'круглосуточно',
};
